import { copyToClipboard, toastEmitter } from "helpers/helpers";

export const copyIframeCode = async (iframeCode: string, t: any) => {
  try {
    await copyToClipboard(iframeCode);
    toastEmitter(t("copyIframeCodeSuccessMsg"), "success");
  } catch (error) {
    toastEmitter(t("errors.copyIframeCodeErrorMsg"), "error");
  }
};
